import { lazy } from 'react';

const pageComponents = {
  'AdvancedCompliance': lazy(
    () => import(/* webpackChunkName: 'change-of-registered-agent' */ '../pages/Products/AdvancedCompliance')
  ),
  'Banking': lazy(
    () => import(/* webpackChunkName: 'banking' */ '../pages/Products/Banking')
  ),
  'BasicCompliance': lazy(
    () => import(/* webpackChunkName: 'change-of-registered-agent' */ '../pages/Products/BasicCompliance')
  ),
  'BeneficialOwnershipInformation': lazy(
    () => import(/* webpackChunkName: 'beneficial-ownership-information' */ '../pages/Products/BeneficialOwnershipInformation')
  ),
  'BusinessInfo': lazy(
    () => import(/* webpackChunkName: 'business-info' */ '../pages/BusinessInfo')
  ),
  'BusinessExperience': lazy(
    () => import(/* webpackChunkName: 'business-experience' */ '../pages/BusinessExperience')
  ),
  'BusinessInfoBOI': lazy(
    () => import(/* webpackChunkName: 'business-info-boi' */ '../pages/BusinessInfoBOI')
  ),
  'BusinessInfoCORA': lazy(
    () => import(/* webpackChunkName: 'business-info-boi' */ '../pages/BusinessInfoCORA')
  ),
  'BusinessLicenseReport': lazy(
    () => import(/* webpackChunkName: 'business-license-report' */ '../pages/Products/BusinessLicenseReport')
  ),
  'BusinessStage': lazy(
    () => import(/* webpackChunkName: 'business-stage' */ '../pages/BusinessStage')
  ),
  'BusinessWebsite': lazy(
    () => import(/* webpackChunkName: 'business-website' */ '../pages/BusinessWebsite')
  ),
  'ChangeOfRegisteredAgent': lazy(
    () => import(/* webpackChunkName: 'change-of-registered-agent' */ '../pages/Products/ChangeOfRegisteredAgent')
  ),
  'Checkout': lazy(
    () => import(/* webpackChunkName: 'checkout' */ '../pages/Checkout')
  ),
  'CheckoutSmartLlc': lazy(
    () => import(/* webpackChunkName: 'checkout-smart-llc' */ '../pages/CheckoutSmartLlc/CheckoutSmartLlc')
  ),
  'Conclusion': lazy(
    () => import(/* webpackChunkName: 'conclusion' */ '../pages/Conclusion')
  ),
  'ConclusionQuote': lazy(
    () => import(/* webpackChunkName: 'conclusion-quote' */ '../pages/ConclusionQuote')
  ),
  'ConclusionSmartLlc': lazy(
    () => import(/* webpackChunkName: 'conclusion-smart-llc' */ '../pages/ConclusionSmartLlc')
  ),
  'Confirmation': lazy(
    () => import(/* webpackChunkName: 'confirmation' */ '../pages/Confirmation')
  ),
  'ContactInfo': lazy(
    () => import(/* webpackChunkName: 'contact-info' */ '../pages/ContactInfo')
  ),
  'CorporateBylaws': lazy(
    () => import(/* webpackChunkName: 'corporate-bylaws' */ '../pages/Products/CorporateBylaws')
  ),
  'DomainNameRegistration': lazy(
    () => import(/* webpackChunkName: 'domain-name' */ '../pages/Products/DomainNameRegistration')
  ),
  'EIN': lazy(
    () => import(/* webpackChunkName: 'ein' */ '../pages/Products/EIN')
  ),
  'FormationReview': lazy(
    () => import(/* webpackChunkName: 'formation-review' */ '../pages/FormationReview')
  ),
  'Industry': lazy(
    () => import(/* webpackChunkName: 'industry' */ '../pages/Industry')
  ),
  'MoneyPro': lazy(
    () => import(/* webpackChunkName: 'money-pro' */ '../pages/Products/MoneyPro')
  ),
  'MultiStateRegisteredAgent': lazy(
    () => import(/* webpackChunkName: 'multi-state-registered-agent' */ '../pages/Products/MultiStateRegisteredAgent')
  ),
  'NewYorkPublication': lazy(
    () => import(/* webpackChunkName: 'ny-publication' */ '../pages/Products/NewYorkPublication')
  ),
  'OperatingAgreement': lazy(
    () => import(/* webpackChunkName: 'oa' */ '../pages/Products/OperatingAgreement')
  ),
  'PlanSelection': lazy(
    () => import(/* webpackChunkName: 'plan-selection' */ '../pages/PlanSelection')
  ),
  'Qualification': lazy(
    () => import(/* webpackChunkName: 'qualification' */ '../pages/Qualification')
  ),
  'RegisteredAgent': lazy(
    () => import(/* webpackChunkName: 'registered-agent' */ '../pages/Products/RegisteredAgent')
  ),
  'RegisteredAgentAndWFC': lazy(
    () => import(/* webpackChunkName: 'registered-agent-and-wfc' */ '../pages/Products/RegisteredAgentAndWFC')
  ),
  'RushFiling': lazy(
    () => import(/* webpackChunkName: 'rush-filing' */ '../pages/Products/RushFiling')
  ),
  'Taxes': lazy(
    () => import(/* webpackChunkName: 'taxes' */ '../pages/Products/Taxes')
  ),
  'WebsiteBuilder': lazy(
    () => import(/* webpackChunkName: 'website-builder' */ '../pages/Products/WebsiteBuilder')
  ),
  'WFC': lazy(
    () => import(/* webpackChunkName: 'wfc' */ '../pages/Products/WFC')
  ),
  // For Mobile flows
  'Guarantee': lazy(
    () => import(/* webpackChunkName: 'guarantee' */ '../pages/Guarantee')
  ),
  'ProductsPhone': lazy(
    () => import(/* webpackChunkName: 'products-phone' */ '../pages/ProductsPhone')
  ),
  'Questions': lazy(
    () => import(/* webpackChunkName: 'questions' */ '../pages/Questions')
  ),
};

export default pageComponents;
